import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Phone } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { COMPANY, tel } from "@/data/company";
import { useSEO } from "@/lib/seo";

export default function ThankYou() {
  useSEO({
    title: "Enquiry Received",
    description: "Your enquiry has been received by Vikas Rolls. Our team will review your requirement and respond shortly.",
  });

  return (
    <section className="relative min-h-[85vh] flex items-center bg-ink bg-blueprint">
      <div className="max-w-3xl mx-auto px-5 md:px-10 py-40 text-center w-full">
        <Reveal>
          <CheckCircle2 size={62} className="text-amber-brand mx-auto mb-8" aria-hidden="true" />
          <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-amber-brand mb-5">Enquiry received</p>
          <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl text-steel-light leading-[1.02] mb-6">
            Thank you. Your requirement is with our team.
          </h1>
          <p className="text-steel text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-12">
            We review every enquiry against your application details and respond with a considered
            recommendation. If anything needs clarifying, we'll contact you at the details you provided.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/" data-testid="thankyou-home-button" className="group inline-flex items-center gap-3 bg-amber-brand text-ink font-display font-bold px-8 py-4 hover:bg-steel-light">
              Back to Home
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <a href={tel(COMPANY.phone.primary)} data-testid="thankyou-call-link" className="inline-flex items-center gap-3 border border-line text-steel-light font-display font-bold px-8 py-4 hover:border-amber-brand hover:text-amber-brand">
              <Phone size={17} /> Urgent? {COMPANY.phone.primary}
            </a>
          </div>
        </Reveal>
      </div>
      <div className="absolute bottom-0 inset-x-0 ticks opacity-50" aria-hidden="true" />
    </section>
  );
}
